(function(){
  if (window.__NBN_LOCATION_PERSONALISATION_LOADED__) return;
  window.__NBN_LOCATION_PERSONALISATION_LOADED__ = true;

  var STORAGE_KEY = 'nbn_delivery_postcode';
  var ACTUAL_POSTCODE_KEY = 'nbn_delivery_postcode_actual';
  var STORE_FILTER_KEY = 'nbn_delivery_store_filter';
  var STORE_FILTER_PARAM_KEY = 'nbn_delivery_store_filter_param';
  var STORE_FILTER_VALUE_KEY = 'nbn_delivery_store_filter_value';
  var RANK_ENDPOINT_STORAGE_KEY = 'nbn_location_rank_endpoint';
  var STOCK_ENDPOINT = 'https://carrier.naughtybutnice.au/stock';
  var DEFAULT_RANK_ENDPOINT = 'https://carrier.naughtybutnice.au/location-rank';
  var POSTCODE_CAPTURE_ENDPOINT = 'https://carrier.naughtybutnice.au/postcode-capture';
  var MAX_COLLECTION_CARDS = 1000;
  var RANK_ENDPOINT_LIMIT = 1000;
  var RANK_ENDPOINT_TIMEOUT_MS = 8000;
  var STOCK_CONCURRENCY = 12;
  var collectionPersonaliseRunning = false;
  var collectionPersonaliseQueued = false;
  var collectionVisibleLoadingRequested = false;
  var collectionReorderRequested = false;
  var collectionObserverBound = false;
  var endpointMissRows = [];
  var endpointMissInfo = null;
  var endpointMissScrollBound = false;
  var endpointMissInterval = null;
  var productVariantCache = {};
  var STORE_FILTER_CACHE_TTL_MS = 5 * 60 * 1000;
  var storeFilterHandleCache = {};
  var LOCATION_GROUPS = {
    brisbane: {
      label: 'Brisbane',
      promise: '2-hour delivery from our Brisbane stores',
      collectionNote: 'Showing local-stocked products first for Brisbane.',
      ids: ['63541706925','71767556269','79725527213']
    },
    goldcoast: {
      label: 'Gold Coast',
      promise: 'same-day delivery from the Gold Coast warehouse',
      collectionNote: 'Showing Gold Coast same-day stock first.',
      ids: ['86314156205']
    },
    sydney: {
      label: 'Sydney',
      promise: '3-hour delivery and Sydney pickup where available',
      collectionNote: 'Showing Sydney warehouse stock first.',
      ids: ['86338404525']
    },
    other: {
      label: 'Australia',
      promise: 'discreet express post and transfer options at checkout',
      collectionNote: 'Enter a local delivery postcode to prioritise nearby stock.',
      ids: []
    }
  };
  var stockCache = {};
  var STORE_FILTER_POSTCODES = [
    { match: /gold coast/i, postcode: '4216', label: 'Gold Coast Warehouse' },
    { match: /sydney/i, postcode: '2565', label: 'Sydney Warehouse' },
    { match: /cannon hill/i, postcode: '4170', label: 'Cannon Hill' },
    { match: /capalaba/i, postcode: '4157', label: 'Capalaba' },
    { match: /margate/i, postcode: '4019', label: 'Margate' }
  ];

  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function cleanPostcode(value){ return String(value || '').replace(/[^0-9]/g,'').slice(0,4); }
  function getPostcode(){ return cleanPostcode(localStorage.getItem(STORAGE_KEY)); }
  function hasActualPostcode(){
    try { return localStorage.getItem(ACTUAL_POSTCODE_KEY) === '1'; }
    catch (error) { return false; }
  }
  function updatePreviewPostcodeParam(postcode){
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('nbn_postcode')) return;
      if (postcode) url.searchParams.set('nbn_postcode', postcode);
      else url.searchParams.delete('nbn_postcode');
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (error) {}
  }
  function setPostcode(postcode, options){
    options = options || {};
    postcode = cleanPostcode(postcode);
    if (postcode.length === 4) {
      localStorage.setItem(STORAGE_KEY, postcode);
      localStorage.setItem(ACTUAL_POSTCODE_KEY, options.actual === false ? '0' : '1');
      updatePreviewPostcodeParam(postcode);
    }
    return postcode;
  }
  function sessionHash(){
    var key = 'nbn_delivery_session_id';
    var id = '';
    try { id = sessionStorage.getItem(key) || ''; } catch (error) {}
    if (!id) {
      id = String(Date.now()) + '-' + Math.random().toString(36).slice(2);
      try { sessionStorage.setItem(key, id); } catch (error) {}
    }
    var hash = 0;
    for (var i = 0; i < id.length; i++) {
      hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
    }
    return Math.abs(hash).toString(36);
  }
  function currentPageType(){
    if (/\/collections\//.test(window.location.pathname)) return 'collection';
    if (/\/products\//.test(window.location.pathname)) return 'product';
    if (document.body && document.body.dataset && document.body.dataset.template) return document.body.dataset.template;
    if (document.querySelector('[data-nbn-location-grid]')) return 'collection';
    if (/\/products\//.test(window.location.pathname) || document.querySelector('[data-nbn-product-widget]')) return 'product';
    return 'site';
  }
  function currentCollectionHandle(){
    var grid = document.querySelector('[data-nbn-location-grid]');
    if (grid && grid.dataset.collectionHandle) return grid.dataset.collectionHandle;
    var match = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }
  function currentProductHandle(){
    if (!/\/products\//.test(window.location.pathname)) return '';
    var product = document.querySelector('[data-nbn-product-handle]');
    if (product && product.dataset.nbnProductHandle) return product.dataset.nbnProductHandle;
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }
  function capturePostcodeEntry(detail){
    detail = detail || {};
    var postcode = cleanPostcode(detail.postcode);
    if (postcode.length !== 4) return;
    var path = window.location.pathname + window.location.search;
    var source = String(detail.source || 'unknown');
    var dedupeKey = postcode + '|' + source + '|' + path;
    var now = Date.now();
    try {
      var last = JSON.parse(sessionStorage.getItem('nbn_last_postcode_capture') || '{}');
      if (last.key === dedupeKey && now - Number(last.at || 0) < 3000) return;
      sessionStorage.setItem('nbn_last_postcode_capture', JSON.stringify({ key: dedupeKey, at: now }));
    } catch (error) {}
    var payload = {
      postcode: postcode,
      zone: detail.zone || zoneFor(postcode),
      source: source,
      store: detail.store || '',
      path: path,
      page_type: currentPageType(),
      collection: currentCollectionHandle(),
      product_handle: currentProductHandle(),
      session_hash: sessionHash()
    };
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(POSTCODE_CAPTURE_ENDPOINT, blob)) return;
      }
    } catch (error) {}
    try {
      fetch(POSTCODE_CAPTURE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        cache: 'no-store'
      }).catch(function(){});
    } catch (error) {}
  }
  function clearPostcode(source){
    var previous = getPostcode();
    try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}
    try { localStorage.removeItem(ACTUAL_POSTCODE_KEY); } catch (error) {}
    try { localStorage.removeItem(STORE_FILTER_KEY); } catch (error) {}
    try { localStorage.removeItem(STORE_FILTER_PARAM_KEY); } catch (error) {}
    try { localStorage.removeItem(STORE_FILTER_VALUE_KEY); } catch (error) {}
    updatePreviewPostcodeParam('');
    document.querySelectorAll('[data-nbn-location-input], [data-nbn-postcode-input]').forEach(function(input){
      input.value = '';
    });
    document.querySelectorAll('[data-nbn-location-card-badge]').forEach(function(badge){
      badge.hidden = true;
    });
    var note = document.querySelector('[data-nbn-location-collection-note]');
    if (note && note.parentNode) note.parentNode.removeChild(note);
    var cartMessage = document.querySelector('[data-nbn-location-cart-message]');
    if (cartMessage && cartMessage.parentNode) cartMessage.parentNode.removeChild(cartMessage);
    applyPersonalisation();
    window.dispatchEvent(new CustomEvent('nbn:postcode-cleared', { detail: { previous: previous, source: source || 'location-bar' } }));
    window.dispatchEvent(new CustomEvent('nbn:postcode-updated', { detail: { postcode: '', zone: 'other', source: source || 'location-bar' } }));
  }
  function storeFilterForValue(value){
    value = String(value || '').trim();
    if (!value) return { postcode: '', label: '' };
    for (var i = 0; i < STORE_FILTER_POSTCODES.length; i++) {
      if (STORE_FILTER_POSTCODES[i].match.test(value)) return STORE_FILTER_POSTCODES[i];
    }
    return null;
  }
  function storeFilterForOption(option){
    if (!option) return null;
    var candidates = [
      option.dataset.storeValue,
      option.dataset.storeLabel,
      option.querySelector('span') && option.querySelector('span').textContent,
      option.textContent
    ];
    for (var i = 0; i < candidates.length; i++) {
      var filter = storeFilterForValue(candidates[i]);
      if (filter) return filter;
    }
    return null;
  }
  function closeStoreSelectorDrawer(){
    var drawer = document.getElementById('Store-Selector-Drawer');
    if (drawer) {
      drawer.classList.remove('active');
      drawer.setAttribute('inert', '');
    }
    if (!document.querySelector('.side-panel.active')) document.body.classList.remove('open-cc');
  }
  function updateStoreSelectorState(label){
    var selectedLabel = label;
    if (selectedLabel === undefined) {
      try { selectedLabel = localStorage.getItem(STORE_FILTER_KEY) || ''; } catch (error) { selectedLabel = ''; }
    }
    var button = document.getElementById('Store-Selector-Toggle');
    if (button) {
      button.classList.toggle('is-active', !!selectedLabel);
      setTextIfChanged(button, selectedLabel || 'Choose store');
    }
    document.querySelectorAll('.nbn-store-option').forEach(function(option){
      var optionValue = option.dataset.storeValue || option.dataset.storeLabel || '';
      var optionFilter = storeFilterForOption(option) || storeFilterForValue(optionValue);
      var optionLabel = optionFilter && optionFilter.label ? optionFilter.label : '';
      option.classList.toggle('active', selectedLabel ? optionLabel === selectedLabel : !optionValue);
    });
  }
  function setCollectionLoading(isLoading){
    var active = !!isLoading;
    var button = document.getElementById('Store-Selector-Toggle');
    if (button) {
      button.classList.toggle('is-loading', active);
      button.setAttribute('aria-busy', active ? 'true' : 'false');
    }
    var grid = document.querySelector('ul#product-grid.products');
    if (grid) grid.classList.toggle('nbn-location-updating', active);
  }
  function findStoreSelectorOption(label){
    label = String(label || '').trim();
    if (!label) return null;
    var options = Array.from(document.querySelectorAll('.nbn-store-option'));
    for (var i = 0; i < options.length; i++) {
      var optionFilter = storeFilterForOption(options[i]);
      if (optionFilter && optionFilter.label === label) return options[i];
    }
    return null;
  }
  function closestStoreForPostcode(postcode){
    postcode = cleanPostcode(postcode);
    var zone = zoneFor(postcode);
    var stores = FAST_DELIVERY_STORES[zone] || [];
    if (!postcode || !stores.length) return null;
    if (stores.length === 1) return stores[0];
    var coords = POSTCODE_COORDS[postcode];
    if (!coords) return stores[0];
    return stores.slice().sort(function(a,b){
      return haversine(coords.lat, coords.lng, a.lat, a.lng) - haversine(coords.lat, coords.lng, b.lat, b.lng);
    })[0];
  }
  function syncStoreSelectorToPostcode(postcode){
    var closest = closestStoreForPostcode(postcode);
    if (!closest || !closest.name) {
      try {
        localStorage.removeItem(STORE_FILTER_KEY);
        localStorage.removeItem(STORE_FILTER_PARAM_KEY);
        localStorage.removeItem(STORE_FILTER_VALUE_KEY);
      } catch (error) {}
      updateStoreSelectorState('');
      return '';
    }
    var option = findStoreSelectorOption(closest.name);
    try {
      localStorage.setItem(STORE_FILTER_KEY, closest.name);
      if (option) {
        localStorage.setItem(STORE_FILTER_PARAM_KEY, option.dataset.storeParam || option.closest('.nbn-store-selector-options')?.dataset.storeParam || 'filter.v.m.multilocation_app.inventory_location');
        localStorage.setItem(STORE_FILTER_VALUE_KEY, option.dataset.storeValue || '');
      } else {
        localStorage.removeItem(STORE_FILTER_PARAM_KEY);
        localStorage.removeItem(STORE_FILTER_VALUE_KEY);
      }
    } catch (error) {}
    updateStoreSelectorState(closest.name);
    return closest.name;
  }
  function applyStoreSelectorOption(option){
    if (!option || option.disabled) return false;
    var filter = storeFilterForOption(option);
    if (!filter) return false;
    if (!filter.postcode) {
      clearPostcode('collection-store-selector');
      closeStoreSelectorDrawer();
      updateStoreSelectorState('');
      return true;
    }
    try {
      localStorage.setItem(STORE_FILTER_KEY, filter.label);
      localStorage.setItem(STORE_FILTER_PARAM_KEY, option.dataset.storeParam || option.closest('.nbn-store-selector-options')?.dataset.storeParam || 'filter.v.m.multilocation_app.inventory_location');
      localStorage.setItem(STORE_FILTER_VALUE_KEY, option.dataset.storeValue || '');
    } catch (error) {}
    var postcode = setPostcode(filter.postcode, { actual: false });
    closeStoreSelectorDrawer();
    setCollectionLoading(true);
    updateStoreSelectorState(filter.label);
    applyPersonalisation({ visibleLoading: true, allowReorder: true });
    window.dispatchEvent(new CustomEvent('nbn:postcode-updated', {
      detail: { postcode: postcode, zone: getZone(), source: 'collection-store-selector', store: filter.label, actualPostcode: false }
    }));
    return true;
  }
  function safeUrl(value){
    try {
      var parsed = new URL(String(value || ''));
      return parsed.protocol === 'https:' ? parsed.toString().replace(/[?#]*$/, '') : '';
    } catch (error) {
      return '';
    }
  }
  function capturePreviewParams(){
    try {
      var params = new URLSearchParams(window.location.search || '');
      var postcode = cleanPostcode(params.get('nbn_postcode'));
      if (postcode.length === 4) {
        setPostcode(postcode, { actual: true });
        syncStoreSelectorToPostcode(postcode);
      }
      var endpoint = safeUrl(params.get('nbn_rank_endpoint'));
      if (endpoint) sessionStorage.setItem(RANK_ENDPOINT_STORAGE_KEY, endpoint);
    } catch (error) {}
  }
  function getRankEndpoint(){
    return safeUrl(sessionStorage.getItem(RANK_ENDPOINT_STORAGE_KEY)) || DEFAULT_RANK_ENDPOINT;
  }
  function hasStoreSelectorFilter(){
    try {
      return !!(localStorage.getItem(STORE_FILTER_KEY) && localStorage.getItem(STORE_FILTER_PARAM_KEY) && localStorage.getItem(STORE_FILTER_VALUE_KEY));
    } catch (error) {
      return false;
    }
  }
  function storeFilterCacheKey(){
    try {
      return [
        getCollectionHandle(),
        localStorage.getItem(STORE_FILTER_KEY) || '',
        localStorage.getItem(STORE_FILTER_PARAM_KEY) || '',
        localStorage.getItem(STORE_FILTER_VALUE_KEY) || '',
        window.location.pathname
      ].join('|');
    } catch (error) {
      return '';
    }
  }
  function getCachedStoreFilteredHandles(){
    var key = storeFilterCacheKey();
    var cached = key && storeFilterHandleCache[key];
    if (!cached || Date.now() - Number(cached.at || 0) > STORE_FILTER_CACHE_TTL_MS) return null;
    return cached.value || null;
  }
  function setCachedStoreFilteredHandles(value){
    var key = storeFilterCacheKey();
    if (!key || !value || !Array.isArray(value.handles) || !value.handles.length) return value;
    storeFilterHandleCache[key] = { at: Date.now(), value: value };
    return value;
  }
  function zoneFor(postcode){
    var pc = parseInt(postcode, 10);
    if (!pc) return 'other';
    if ((pc >= 2000 && pc <= 2234) || (pc >= 2555 && pc <= 2574) || (pc >= 2745 && pc <= 2770)) return 'sydney';
    if (pc >= 4200 && pc <= 4230) return 'goldcoast';
    if ((pc >= 4000 && pc <= 4189) || (pc >= 4300 && pc <= 4305) || (pc >= 4500 && pc <= 4510)) return 'brisbane';
    return 'other';
  }
  function getZone(){ return zoneFor(getPostcode()); }
  function locationInfo(){ return LOCATION_GROUPS[getZone()] || LOCATION_GROUPS.other; }
  function escapeHtml(value){
    return String(value || '').replace(/[&<>"']/g, function(char){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char];
    });
  }
  var FAST_DELIVERY_STORES = {
    brisbane: [
      { name:'Cannon Hill', lat:-27.4698, lng:153.0851 },
      { name:'Capalaba', lat:-27.5167, lng:153.1833 },
      { name:'Margate', lat:-27.0333, lng:153.0833 }
    ],
    goldcoast: [
      { name:'Gold Coast Warehouse', lat:-27.92546, lng:153.37719 }
    ],
    sydney: [
      { name:'Sydney Warehouse', lat:-34.00185, lng:150.85301 }
    ]
  };
  var POSTCODE_COORDS = {
    2000:{lat:-33.8688,lng:151.2093},2234:{lat:-34.0230,lng:151.0450},
    2555:{lat:-33.9400,lng:150.8500},2564:{lat:-33.9920,lng:150.8900},2565:{lat:-34.00185,lng:150.85301},2566:{lat:-34.0280,lng:150.8500},2574:{lat:-34.3890,lng:150.5800},
    2745:{lat:-33.7590,lng:150.6860},2770:{lat:-33.7680,lng:150.8150},
    4000:{lat:-27.4679,lng:153.0281},4001:{lat:-27.4832,lng:153.0178},4005:{lat:-27.4885,lng:153.0068},4006:{lat:-27.4501,lng:153.0436},
    4007:{lat:-27.4567,lng:153.0355},4009:{lat:-27.4601,lng:152.9934},4010:{lat:-27.4566,lng:153.0070},4011:{lat:-27.4491,lng:152.9962},
    4012:{lat:-27.4635,lng:153.0004},4013:{lat:-27.4525,lng:153.0270},4014:{lat:-27.3333,lng:153.0667},4017:{lat:-27.3167,lng:153.0667},
    4018:{lat:-27.3667,lng:153.1000},4019:{lat:-27.0167,lng:153.0833},4020:{lat:-27.0333,lng:153.0833},4021:{lat:-27.0500,lng:153.0833},
    4022:{lat:-27.2114,lng:153.0550},4025:{lat:-27.0333,lng:153.0500},4030:{lat:-27.4167,lng:153.0500},4031:{lat:-27.4000,lng:153.0333},
    4032:{lat:-27.3833,lng:153.0167},4034:{lat:-27.4547,lng:153.0800},4035:{lat:-27.4428,lng:153.1236},4036:{lat:-27.3667,lng:153.0333},
    4037:{lat:-27.3500,lng:153.0167},4051:{lat:-27.4167,lng:153.0000},4053:{lat:-27.4046,lng:153.0357},4054:{lat:-27.3956,lng:153.0188},
    4055:{lat:-27.4167,lng:152.9667},4059:{lat:-27.4491,lng:152.9962},4060:{lat:-27.4601,lng:152.9934},4061:{lat:-27.4635,lng:153.0004},
    4064:{lat:-27.4525,lng:153.0270},4065:{lat:-27.4867,lng:152.9695},4066:{lat:-27.5109,lng:152.9708},4067:{lat:-27.5316,lng:152.9699},
    4068:{lat:-27.5566,lng:152.9540},4069:{lat:-27.5205,lng:153.0598},4070:{lat:-27.5621,lng:153.0654},4072:{lat:-27.5773,lng:153.0715},
    4073:{lat:-27.5857,lng:153.1232},4074:{lat:-27.6371,lng:153.1307},4075:{lat:-27.5167,lng:153.1833},4076:{lat:-27.5436,lng:153.2176},
    4077:{lat:-27.5954,lng:152.9723},4078:{lat:-27.6201,lng:152.9584},4101:{lat:-27.4764,lng:153.0152},4102:{lat:-27.4825,lng:153.0461},
    4103:{lat:-27.4912,lng:153.0590},4104:{lat:-27.5054,lng:153.0247},4105:{lat:-27.5316,lng:153.0699},4107:{lat:-27.5621,lng:153.0654},
    4108:{lat:-27.5773,lng:153.0715},4109:{lat:-27.6257,lng:152.7592},4110:{lat:-27.5837,lng:152.8897},4111:{lat:-27.5675,lng:152.9406},
    4112:{lat:-27.5346,lng:152.8680},4113:{lat:-27.5773,lng:153.0715},4114:{lat:-27.5857,lng:153.1232},4115:{lat:-27.6371,lng:153.1307},
    4116:{lat:-27.5773,lng:153.0715},4117:{lat:-27.5857,lng:153.1232},4118:{lat:-27.5346,lng:152.8680},4119:{lat:-27.5773,lng:153.0715},
    4120:{lat:-27.5205,lng:153.0598},4121:{lat:-27.5316,lng:153.0699},4122:{lat:-27.5621,lng:153.0654},4123:{lat:-27.5773,lng:153.0715},
    4124:{lat:-27.6053,lng:153.0801},4125:{lat:-27.6371,lng:153.1307},4127:{lat:-27.6371,lng:153.1307},4128:{lat:-27.6371,lng:153.1307},
    4129:{lat:-27.6053,lng:153.0801},4130:{lat:-27.5857,lng:153.1232},4131:{lat:-27.5205,lng:153.0598},4132:{lat:-27.5621,lng:153.0654},
    4133:{lat:-27.6371,lng:153.1307},4151:{lat:-27.5205,lng:153.0598},4152:{lat:-27.3838,lng:153.0145},4153:{lat:-27.3682,lng:153.0233},
    4154:{lat:-27.3439,lng:153.0552},4155:{lat:-27.3290,lng:153.0816},4156:{lat:-27.3290,lng:153.0816},4157:{lat:-27.5167,lng:153.1833},
    4158:{lat:-27.5125,lng:153.1955},4159:{lat:-27.4989,lng:153.2127},4160:{lat:-27.4833,lng:153.2333},4161:{lat:-27.5333,lng:153.2000},
    4163:{lat:-27.5333,lng:153.2667},4164:{lat:-27.5667,lng:153.2333},4165:{lat:-27.6167,lng:153.3000},4169:{lat:-27.4825,lng:153.0461},
    4170:{lat:-27.4698,lng:153.0851},4171:{lat:-27.4547,lng:153.0800},4172:{lat:-27.4428,lng:153.1236},4173:{lat:-27.4047,lng:153.0863},
    4174:{lat:-27.4333,lng:153.1000},4178:{lat:-27.4428,lng:153.1236},4179:{lat:-27.0333,lng:153.0833},
    4205:{lat:-27.6667,lng:153.1333},4207:{lat:-27.9752,lng:153.4118},4209:{lat:-27.8667,lng:153.3333},4210:{lat:-27.9333,lng:153.3667},
    4211:{lat:-27.8667,lng:153.3000},4212:{lat:-27.8667,lng:153.3667},4213:{lat:-28.0667,lng:153.4000},4214:{lat:-27.9667,lng:153.4000},
    4215:{lat:-28.0028,lng:153.4286},4216:{lat:-27.92546,lng:153.37719},4217:{lat:-27.9667,lng:153.4286},4218:{lat:-28.0333,lng:153.4333},
    4300:{lat:-27.6695,lng:152.8993},4305:{lat:-27.6167,lng:152.7667},4500:{lat:-26.6841,lng:153.0939},4501:{lat:-27.1667,lng:153.0000},
    4502:{lat:-27.2333,lng:152.9667},4503:{lat:-27.2167,lng:153.0000},4504:{lat:-27.2500,lng:152.9833},4505:{lat:-27.2667,lng:152.9667},
    4506:{lat:-27.2833,lng:152.9500},4507:{lat:-27.2667,lng:153.1000},4508:{lat:-27.2333,lng:153.0333},4509:{lat:-27.2500,lng:153.0500},
    4510:{lat:-27.0833,lng:152.9667}
  };
  function haversine(lat1, lng1, lat2, lng2){
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1*Math.PI/180) * Math.cos(lat2*Math.PI/180) * Math.sin(dLng/2) * Math.sin(dLng/2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }
  function get2hrRateCents(distKm){
    if (distKm <= 10) return 995;
    if (distKm <= 15) return 1695;
    if (distKm <= 20) return 1995;
    if (distKm <= 25) return 3495;
    if (distKm <= 30) return 3995;
    if (distKm <= 35) return 4495;
    if (distKm <= 40) return 4995;
    if (distKm <= 45) return 5995;
    if (distKm <= 50) return 6995;
    if (distKm <= 55) return 7995;
    if (distKm <= 60) return 8995;
    return null;
  }
  function formatRate(cents){
    return cents === 0 ? 'Free' : '$' + (cents / 100).toFixed(2);
  }
  function estimateDeliveryRateLabel(postcode, zone){
    var coords = POSTCODE_COORDS[parseInt(postcode, 10)];
    var stores = FAST_DELIVERY_STORES[zone] || [];
    if (!coords || !stores.length) return '';
    var rates = stores.map(function(store){
      return get2hrRateCents(haversine(coords.lat, coords.lng, store.lat, store.lng));
    }).filter(function(rate){ return rate !== null; }).sort(function(a,b){ return a - b; });
    if (!rates.length) return '';
    var min = rates[0];
    var max = rates[rates.length - 1];
    return min === max ? formatRate(min) : formatRate(min) + '-' + formatRate(max);
  }
  function estimatedDeliveryText(postcode, zone){
    if (!hasActualPostcode()) return 'Starting from $9.95';
    var label = estimateDeliveryRateLabel(postcode, zone);
    if (label) return 'Est. delivery: ' + label;
    return 'Estimated rate uses your postcode.';
  }
  function localNow(timeZone){
    return new Date(new Date().toLocaleString('en-US', { timeZone: timeZone }));
  }
  function ymd(date){
    return date.getFullYear()+'-'+String(date.getMonth()+1).padStart(2,'0')+'-'+String(date.getDate()).padStart(2,'0');
  }
  function atTime(date, time){
    var parts = time.split(':').map(Number);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), parts[0], parts[1], 0);
  }
  function labelTime(time){
    var parts = time.split(':').map(Number);
    var h = parts[0], m = parts[1] || 0;
    var suffix = h >= 12 ? 'pm' : 'am';
    var hour = h % 12 || 12;
    return hour + (m ? ':' + String(m).padStart(2,'0') : '') + suffix;
  }
  function dayLabel(date, today, timeZone){
    timeZone = timeZone || 'Australia/Brisbane';
    if (today) return 'today';
    var zoneNow = localNow(timeZone);
    var tomorrow = new Date(zoneNow.getFullYear(), zoneNow.getMonth(), zoneNow.getDate() + 1, 0, 0, 0);
    if (ymd(date) === ymd(tomorrow)) return 'tomorrow';
    return date.toLocaleDateString('en-AU', { weekday: 'long' });
  }
  function weekdayLabel(date){
    return date.toLocaleDateString('en-AU', { weekday: 'long' });
  }
  var QLD_PUBLIC_HOLIDAYS = {
    '2026-01-01':true,'2026-01-26':true,'2026-04-03':true,'2026-04-04':true,'2026-04-05':true,'2026-04-06':true,
    '2026-04-25':true,'2026-05-04':true,'2026-10-05':true,'2026-12-25':true,'2026-12-26':true,'2026-12-28':true
  };
  function brisbaneEkkaShowDayDate(year){
    var firstFriday = null;
    for (var day = 1; day <= 7; day++) {
      var candidate = new Date(year, 7, day, 0, 0, 0);
      if (candidate.getDay() === 5) {
        firstFriday = candidate;
        break;
      }
    }
    if (!firstFriday) return null;
    var showStart = new Date(firstFriday.getFullYear(), firstFriday.getMonth(), firstFriday.getDate(), 0, 0, 0);
    if (showStart.getDate() < 5) showStart.setDate(showStart.getDate() + 7);
    return new Date(showStart.getFullYear(), showStart.getMonth(), showStart.getDate() + 5, 0, 0, 0);
  }
  function isBrisbaneEkkaShowDay(date){
    var ekka = brisbaneEkkaShowDayDate(date.getFullYear());
    return !!(ekka && ymd(date) === ymd(ekka));
  }
  var NSW_PUBLIC_HOLIDAYS = {
    '2026-01-01':true,'2026-01-26':true,'2026-04-03':true,'2026-04-04':true,'2026-04-05':true,'2026-04-06':true,
    '2026-04-25':true,'2026-06-08':true,'2026-10-05':true,'2026-12-25':true,'2026-12-26':true,'2026-12-28':true
  };
  var PRE_POSTCODE_EYEBROW = 'Fast local delivery';
  var PRE_POSTCODE_HEADING = 'Check fast delivery in Brisbane, Gold Coast & Sydney.';
  var PRE_POSTCODE_SUMMARY = 'Brisbane, Gold Coast and Sydney. Enter your postcode to see stock available for fast delivery near you.';
  var PRE_POSTCODE_MESSAGE = 'Enter your postcode to see the fastest delivery options and nearby stock for your area.';
  function isBusinessDay(date, holidays){
    var dow = date.getDay();
    return dow !== 0 && dow !== 6 && !(holidays && holidays[ymd(date)]);
  }
  function nextExpressDispatchDate(now){
    now = now || localNow('Australia/Brisbane');
    for (var i = 0; i < 10; i++) {
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      if (!isBusinessDay(date, QLD_PUBLIC_HOLIDAYS)) continue;
      if (i === 0 && now >= atTime(date, '12:00')) continue;
      return date;
    }
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
  }
  function addBusinessDays(date, days){
    var cursor = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    var added = 0;
    while (added < days) {
      cursor.setDate(cursor.getDate() + 1);
      if (isBusinessDay(cursor, QLD_PUBLIC_HOLIDAYS) && isBusinessDay(cursor, NSW_PUBLIC_HOLIDAYS)) added++;
    }
    return cursor;
  }
  function destinationStateForPostcode(postcode){
    var pc = parseInt(postcode, 10);
    if (!pc && pc !== 0) return '';
    if ((pc >= 1000 && pc <= 2599) || (pc >= 2619 && pc <= 2899) || (pc >= 2921 && pc <= 2999)) return 'NSW';
    if ((pc >= 2600 && pc <= 2618) || (pc >= 2900 && pc <= 2920)) return 'ACT';
    if ((pc >= 3000 && pc <= 3999) || (pc >= 8000 && pc <= 8999)) return 'VIC';
    if ((pc >= 4000 && pc <= 4999) || (pc >= 9000 && pc <= 9999)) return 'QLD';
    if ((pc >= 5000 && pc <= 5799) || (pc >= 5800 && pc <= 5999)) return 'SA';
    if ((pc >= 6000 && pc <= 6797) || (pc >= 6800 && pc <= 6999)) return 'WA';
    if ((pc >= 7000 && pc <= 7799) || (pc >= 7800 && pc <= 7999)) return 'TAS';
    if (pc >= 800 && pc <= 999) return 'NT';
    return '';
  }
  function expressTransitBusinessDays(postcode){
    var state = destinationStateForPostcode(postcode);
    if (state === 'QLD') return 1;
    if (state === 'NSW' || state === 'ACT' || state === 'VIC') return 2;
    return 3;
  }
  function formatExpressEtaDate(date){
    return date.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long' });
  }
  function expressPostEta(postcode){
    postcode = cleanPostcode(postcode || getPostcode());
    var dispatch = nextExpressDispatchDate();
    var eta = addBusinessDays(dispatch, expressTransitBusinessDays(postcode));
    return {
      date: eta,
      badge: 'Express Post ETA ' + formatExpressEtaDate(eta),
      detail: 'Express Post ETA ' + formatExpressEtaDate(eta) + '. Final postage options show at checkout.'
    };
  }
  function nextBrisbaneCutoff(now){
    now = now || localNow('Australia/Brisbane');
    var cutoffs = {0:'17:45',1:'18:45',2:'18:45',3:'20:45',4:'20:45',5:'20:45',6:'20:45'};
    for (var i = 0; i < 8; i++) {
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      var isEkka = isBrisbaneEkkaShowDay(date);
      var isStateHoliday = !!QLD_PUBLIC_HOLIDAYS[ymd(date)];
      var cutoff = isStateHoliday ? '17:45' : (cutoffs[date.getDay()] || '18:45');
      var target = atTime(date, cutoff);
      if (now < target) return { target: target, cutoff: cutoff, today: i === 0, holiday: isStateHoliday, ekkaBrisbaneOnly: isEkka };
    }
    return null;
  }
  function nextGoldCoastCutoff(now){
    now = now || localNow('Australia/Brisbane');
    for (var i = 0; i < 10; i++) {
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      var dow = date.getDay();
      if (dow === 0 || dow === 6 || QLD_PUBLIC_HOLIDAYS[ymd(date)]) continue;
      var target = atTime(date, '13:00');
      if (now < target) return { target: target, cutoff: '13:00', arrives: '5pm', date: date, today: i === 0, holiday: false };
    }
    return null;
  }
  function nextSydneyCutoff(now){
    now = now || localNow('Australia/Sydney');
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    var todayDow = today.getDay();
    var serviceClosedToday = todayDow === 0 || todayDow === 6 || !!NSW_PUBLIC_HOLIDAYS[ymd(today)];
    for (var i = 0; i < 10; i++) {
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      var dow = date.getDay();
      if (dow === 0 || dow === 6 || NSW_PUBLIC_HOLIDAYS[ymd(date)]) continue;
      var windows = dow === 5
        ? [
            { cutoff:'11:00', arrives:'2pm' },
            { cutoff:'14:00', arrives:'5pm' }
          ]
        : [
            { cutoff:'11:00', arrives:'2pm' },
            { cutoff:'15:00', arrives:'6pm' }
          ];
      for (var j = 0; j < windows.length; j++) {
        var target = atTime(date, windows[j].cutoff);
        if (now < target) {
          return {
            target: target,
            cutoff: windows[j].cutoff,
            arrives: windows[j].arrives,
            date: date,
            today: i === 0,
            holiday: false,
            serviceClosedToday: serviceClosedToday
          };
        }
      }
    }
    return null;
  }
  function isSydneySameDayWindow(syd){
    return !!(syd && syd.today && !syd.serviceClosedToday);
  }
  function nextSydneyWindowAfter(syd){
    if (!syd || !syd.target) return null;
    var now = new Date(syd.target.getTime() + 1000);
    for (var i = 0; i < 10; i++) {
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      var dow = date.getDay();
      if (dow === 0 || dow === 6 || NSW_PUBLIC_HOLIDAYS[ymd(date)]) continue;
      var windows = dow === 5
        ? [
            { cutoff:'11:00', arrives:'2pm' },
            { cutoff:'14:00', arrives:'5pm' }
          ]
        : [
            { cutoff:'11:00', arrives:'2pm' },
            { cutoff:'15:00', arrives:'6pm' }
          ];
      for (var j = 0; j < windows.length; j++) {
        var target = atTime(date, windows[j].cutoff);
        if (now < target) {
          return {
            target: target,
            cutoff: windows[j].cutoff,
            arrives: windows[j].arrives,
            date: date,
            today: i === 0
          };
        }
      }
    }
    return null;
  }
  function sydneyWindowLine(syd){
    var next = nextSydneyWindowAfter(syd);
    if (!next) return 'Next window updates after this cutoff.';
    var isToday = !!(next.today && syd && syd.today);
    return 'Next window: order by ' + labelTime(next.cutoff) + ' ' + dayLabel(next.date, isToday, 'Australia/Sydney') + ' -> delivery by ' + next.arrives;
  }
  function diffParts(ms){
    ms = Math.max(0, ms);
    var s = Math.floor(ms / 1000);
    var h = Math.floor(s / 3600);
    s -= h * 3600;
    var m = Math.floor(s / 60);
    s -= m * 60;
    return { h:h, m:m, s:s };
  }
  function setTextIfChanged(element, value){
    if (!element) return;
    value = String(value || '');
    if (element.textContent !== value) element.textContent = value;
  }
  function setHtmlIfChanged(element, value){
    if (!element) return;
    value = String(value || '');
    if (element.innerHTML !== value) element.innerHTML = value;
  }
  function deliverySummaryForZone(zone){
    var postcode = getPostcode();
    var estimateText = estimatedDeliveryText(postcode, zone);
    if (zone === 'sydney') {
      var syd = nextSydneyCutoff();
      var sydDay = syd ? dayLabel(syd.date, syd.today, 'Australia/Sydney') : 'the next business day';
      var sydClosedToday = !!(syd && syd.serviceClosedToday);
      var sydSameDay = isSydneySameDayWindow(syd);
      if (sydClosedToday) sydDay = weekdayLabel(syd.date);
      var sydPrimary = sydClosedToday
        ? 'Next cutoff: ' + labelTime(syd.cutoff) + ' ' + sydDay + ' -> delivery by ' + syd.arrives
        : (syd
          ? 'Order by ' + labelTime(syd.cutoff) + ' ' + sydDay + ' -> delivery by ' + syd.arrives
          : 'Next Sydney 3-hour window opens on the next business day');
      var sydBulletHtml = '' +
        '<ul class="nbn-delivery-compact__bullets">' +
          '<li><strong>' + escapeHtml(sydPrimary) + '</strong></li>' +
          '<li><strong>' + escapeHtml(sydneyWindowLine(syd)) + '</strong></li>' +
          '<li><strong>Click & Collect available.</strong> ' + escapeHtml(estimateText) + '</li>' +
        '</ul>' +
        '<span class="nbn-delivery-compact__fineprint">Final stock and rate confirmed at checkout.</span>';
      var sydExtraPromise = ' ' + sydneyWindowLine(syd) + '. Click & Collect available. ' + estimateText;
      var sydPromise = sydClosedToday
        ? 'Sydney 3-hour delivery is closed today. Next cutoff is ' + labelTime(syd.cutoff) + ' ' + sydDay + ' for delivery by ' + syd.arrives + '.' + sydExtraPromise
        : (syd
          ? 'Order before ' + labelTime(syd.cutoff) + ' ' + sydDay + ' for discreet Sydney delivery by ' + syd.arrives + '.' + sydExtraPromise
          : 'Sydney 3-hour delivery will process on the next business day.' + sydExtraPromise);
      var sydHeading = sydClosedToday
        ? 'Sydney 3-hour delivery is closed today.'
        : (sydSameDay ? 'Need it today? Sydney 3-hour delivery.' : 'Next Sydney 3-hour delivery window.');
      return {
        eyebrow: 'Sydney delivery',
        heading: sydHeading,
        promise: sydPromise,
        promiseHtml: sydBulletHtml,
        countdownLabel: sydSameDay ? 'Cutoff in' : 'Next cutoff in',
        target: syd && syd.target,
        showSeconds: !!(syd && syd.target)
      };
    }
    if (zone === 'goldcoast') {
      var gc = nextGoldCoastCutoff();
      var gcDay = gc ? dayLabel(gc.date, gc.today) : 'the next business day';
      var gcPromise = gc
        ? 'Order before 1pm ' + gcDay + ' for discreet Gold Coast same-day delivery by 5pm.'
        : 'Gold Coast same-day delivery will process on the next business day.';
      var gcPrimary = gc
        ? 'Order by 1pm ' + gcDay + ' -> delivery by 5pm'
        : 'Next Gold Coast same-day delivery window';
      var gcBulletHtml = '' +
        '<ul class="nbn-delivery-compact__bullets">' +
          '<li><strong>' + escapeHtml(gcPrimary) + '</strong></li>' +
          '<li><strong>Same-day delivery</strong> from the Gold Coast warehouse</li>' +
          '<li><strong>' + escapeHtml(estimateText) + '</strong></li>' +
        '</ul>' +
        '<span class="nbn-delivery-compact__fineprint">Final stock and rate confirmed at checkout.</span>';
      return {
        eyebrow: 'Gold Coast delivery',
        heading: gc && gc.today ? 'Need it today? Gold Coast same-day delivery.' : 'Missed today’s Gold Coast same-day cutoff?',
        promise: gcPromise + ' ' + estimateText,
        promiseHtml: gcBulletHtml,
        countdownLabel: gc && gc.today ? 'Cutoff in' : 'Next cutoff in',
        target: gc && gc.target,
        showSeconds: !!(gc && gc.target)
      };
    }
    if (zone === 'brisbane') {
      var bne = nextBrisbaneCutoff();
      var isEkkaToday = !!(bne && bne.today && bne.ekkaBrisbaneOnly);
      var bnePrimary = bne && bne.today
        ? 'Order by ' + labelTime(bne.cutoff) + ' today'
        : 'Next orders process from 9:30am next business day';
      var bneStoreLine = isEkkaToday
        ? '<li><strong>Capalaba and Margate open normal hours today.</strong> Cannon Hill is closed for Brisbane Ekka Show Day.</li>'
        : '<li><strong>2-hour delivery</strong> from Brisbane stores</li>';
      var bneEstimateLine = isEkkaToday
        ? '<li><strong>' + escapeHtml(estimateText) + '</strong> if stock is available from Capalaba or Margate</li>'
        : '<li><strong>' + escapeHtml(estimateText) + '</strong> if stock comes from one or more stores</li>';
      var bneBulletHtml = '' +
        '<ul class="nbn-delivery-compact__bullets">' +
          '<li><strong>' + escapeHtml(bnePrimary) + '</strong></li>' +
          bneStoreLine +
          bneEstimateLine +
        '</ul>' +
        '<span class="nbn-delivery-compact__fineprint">Final stock and rate confirmed at checkout.</span>';
      return {
        eyebrow: isEkkaToday ? 'Brisbane Ekka Show Day delivery' : 'Brisbane local delivery',
        heading: bne && bne.today ? 'Need it tonight? Brisbane 2-hour delivery.' : 'Missed today’s Brisbane 2-hour cutoff?',
        promise: (bne && bne.today ? 'Order before ' + labelTime(bne.cutoff) + (isEkkaToday ? ' for 2-hour delivery from Capalaba or Margate. Cannon Hill is closed for Brisbane Ekka Show Day.' : ' for discreet 2-hour delivery from your nearest Brisbane store.') : 'Order now and Brisbane 2-hour delivery will process from 9:30am next business day.') + ' ' + estimateText,
        promiseHtml: bneBulletHtml,
        countdownLabel: bne && bne.today ? 'Cutoff in' : 'Next cutoff in',
        target: bne && bne.target,
        showSeconds: !!(bne && bne.target)
      };
    }
    return {
      eyebrow: 'Express Post',
      heading: 'Outside fast local delivery range.',
      promise: expressPostEta().detail,
      countdownLabel: '',
	      target: null
	    };
	  }

  function updateCountdownElement(timer, summary, parts){
    if (!timer) return;
    var showSeconds = !!summary.showSeconds;
    var targetValue = summary.target ? String(summary.target.getTime()) : '';
    var timeZoneValue = getZone() === 'sydney' ? 'Australia/Sydney' : 'Australia/Brisbane';
    var targetChanged = timer.dataset.nbnCountdownTarget !== targetValue;
    var timeZoneChanged = timer.dataset.nbnCountdownTimeZone !== timeZoneValue;
    timer.dataset.nbnCountdownTarget = targetValue;
    timer.dataset.nbnCountdownTimeZone = timeZoneValue;
    if (
      timer.dataset.nbnCountdownLabel !== summary.countdownLabel ||
      timer.dataset.nbnCountdownSeconds !== String(showSeconds) ||
      targetChanged ||
      timeZoneChanged ||
      !timer.querySelector('[data-nbn-countdown-hours]') ||
      !timer.querySelector('[data-nbn-countdown-minutes]')
    ) {
      timer.dataset.nbnCountdownLabel = summary.countdownLabel;
      timer.dataset.nbnCountdownSeconds = String(showSeconds);
      timer.innerHTML = '' +
        '<span class="nbn-countdown-label"></span>' +
        '<span class="nbn-countdown-value" data-nbn-countdown-hours></span>' +
        '<span class="nbn-countdown-unit nbn-countdown-unit--hours">hrs</span>' +
        '<span class="nbn-countdown-value" data-nbn-countdown-minutes></span>' +
        '<span class="nbn-countdown-unit nbn-countdown-unit--minutes">mins</span>' +
        (showSeconds
          ? '<span class="nbn-countdown-value nbn-countdown-seconds" data-nbn-countdown-seconds></span><span class="nbn-countdown-unit nbn-countdown-unit--seconds">sec</span>'
          : '');
      var label = timer.querySelector('.nbn-countdown-label');
      setTextIfChanged(label, summary.countdownLabel);
    }
    var hours = timer.querySelector('[data-nbn-countdown-hours]');
    var minutes = timer.querySelector('[data-nbn-countdown-minutes]');
    var seconds = timer.querySelector('[data-nbn-countdown-seconds]');
    setTextIfChanged(hours, String(parts.h).padStart(2,'0'));
    setTextIfChanged(minutes, String(parts.m).padStart(2,'0'));
    setTextIfChanged(seconds, String(parts.s).padStart(2,'0'));
  }

  function updateCountdownTimersOnly(){
    document.querySelectorAll('[data-nbn-countdown][data-nbn-countdown-target]').forEach(function(timer){
      var targetMs = parseInt(timer.dataset.nbnCountdownTarget || '0', 10);
      if (!targetMs) return;
      var timeZone = timer.dataset.nbnCountdownTimeZone || 'Australia/Brisbane';
      var parts = diffParts(targetMs - localNow(timeZone).getTime());
      var hours = timer.querySelector('[data-nbn-countdown-hours]');
      var minutes = timer.querySelector('[data-nbn-countdown-minutes]');
      var seconds = timer.querySelector('[data-nbn-countdown-seconds]');
      setTextIfChanged(hours, String(parts.h).padStart(2,'0'));
      setTextIfChanged(minutes, String(parts.m).padStart(2,'0'));
      setTextIfChanged(seconds, String(parts.s).padStart(2,'0'));
    });
  }

  function installBar(){
    if (document.querySelector('[data-nbn-location-bar]')) return;
    var header = document.querySelector('#wrapper > .shopify-section-group-header-group') || document.querySelector('header') || document.querySelector('#wrapper');
    if (!header || !header.parentNode) return;
    var postcode = getPostcode();
    var info = locationInfo();
    var summary = deliverySummaryForZone(getZone());
    var bar = document.createElement('section');
    bar.className = 'nbn-location-bar is-collapsed';
    bar.setAttribute('data-nbn-location-bar','');
    bar.innerHTML = ''+
      '<div class="nbn-location-bar__inner">'+
        '<button type="button" class="nbn-location-bar__toggle" data-nbn-location-toggle aria-expanded="false">'+
          '<span class="nbn-location-bar__toggle-copy">'+
            '<strong>Need it Fast? 🚀</strong>'+
            '<span>Fast local delivery and discreet shipping options</span>'+
          '</span>'+
          '<span class="nbn-location-bar__current" data-nbn-location-title>'+escapeHtml(postcode ? info.label + ' ' + postcode : 'Postcode')+'</span>'+
          '<span class="nbn-location-bar__chevron" aria-hidden="true">⌄</span>'+
        '</button>'+
        '<div class="nbn-location-bar__panel" data-nbn-location-panel hidden>'+
          '<span class="nbn-location-bar__promise" data-nbn-location-promise>'+escapeHtml(postcode ? summary.promise : 'Enter your postcode to see fast delivery options and nearby stock for your area.')+'</span>'+
          '<form class="nbn-location-bar__form" data-nbn-location-form>'+
            '<input data-nbn-location-input inputmode="numeric" autocomplete="postal-code" maxlength="4" placeholder="Postcode" value="'+escapeHtml(postcode)+'">'+
            '<button type="submit" data-nbn-location-submit>'+escapeHtml(postcode ? 'Update postcode' : 'Check postcode')+'</button>'+
            '<button type="button" class="nbn-location-bar__clear" data-nbn-location-clear '+(postcode ? '' : 'hidden')+'>Clear postcode</button>'+
          '</form>'+
        '</div>'+
      '</div>';
    header.parentNode.insertBefore(bar, header.nextSibling);
    var toggle = bar.querySelector('[data-nbn-location-toggle]');
    var panel = bar.querySelector('[data-nbn-location-panel]');
    var form = bar.querySelector('[data-nbn-location-form]');
    var input = bar.querySelector('[data-nbn-location-input]');
    var clear = bar.querySelector('[data-nbn-location-clear]');
    function setExpanded(expanded){
      bar.classList.toggle('is-expanded', expanded);
      bar.classList.toggle('is-collapsed', !expanded);
      if (panel) panel.hidden = !expanded;
      if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded && input) setTimeout(function(){ input.focus(); }, 0);
    }
    toggle.addEventListener('click', function(){
      setExpanded(!bar.classList.contains('is-expanded'));
    });
    form.addEventListener('submit', function(event){
      event.preventDefault();
      var nextPostcode = setPostcode(input.value, { actual: true });
      if (nextPostcode.length !== 4) {
        bar.classList.add('is-error');
        setExpanded(true);
        return;
      }
      bar.classList.remove('is-error');
      var closestStore = syncStoreSelectorToPostcode(nextPostcode);
      applyPersonalisation({ visibleLoading: true, allowReorder: true });
      setExpanded(false);
      window.dispatchEvent(new CustomEvent('nbn:postcode-updated', { detail: { postcode: nextPostcode, zone: getZone(), source: 'location-bar', store: closestStore, actualPostcode: true } }));
    });
    if (clear) {
      clear.addEventListener('click', function(event){
        event.preventDefault();
        clearPostcode('location-bar');
        setExpanded(true);
      });
    }
  }

  function updateBar(){
    var bar = document.querySelector('[data-nbn-location-bar]');
    if (!bar) return;
    var postcode = getPostcode();
    var info = locationInfo();
    var summary = deliverySummaryForZone(getZone());
    var title = bar.querySelector('[data-nbn-location-title]');
    var promise = bar.querySelector('[data-nbn-location-promise]');
    var input = bar.querySelector('[data-nbn-location-input]');
    var submit = bar.querySelector('[data-nbn-location-submit]');
    var clear = bar.querySelector('[data-nbn-location-clear]');
    setTextIfChanged(title, postcode ? info.label + ' ' + postcode : 'Postcode');
    setTextIfChanged(promise, postcode ? summary.promise : 'Enter your postcode to see fast delivery options and nearby stock for your area.');
    if (input && input.value !== postcode) input.value = postcode;
    setTextIfChanged(submit, postcode ? 'Update postcode' : 'Check postcode');
    if (clear) clear.hidden = !postcode;
    bar.dataset.nbnZone = getZone();
  }

  function updateExistingDeliveryPanels(){
    var postcode = getPostcode();
    var info = locationInfo();
    var summary = deliverySummaryForZone(getZone());
    document.querySelectorAll('[data-nbn-delivery-panel]').forEach(function(panel){
      var isHomePanel = !!(panel.closest && panel.closest('[data-nbn-home-trust]'));
      if (isHomePanel && postcode && !hasActualPostcode()) {
        postcode = '';
        info = LOCATION_GROUPS.brisbane;
        summary = deliverySummaryForZone('brisbane');
      }
      var eyebrow = panel.querySelector('.nbn-delivery-compact__eyebrow');
      var heading = panel.querySelector('[data-nbn-delivery-heading]');
      var message = panel.querySelector('[data-nbn-delivery-message]');
      var summaryLine = panel.querySelector('[data-nbn-delivery-summary]');
      var timer = panel.querySelector('[data-nbn-countdown]');
      var input = panel.querySelector('[data-nbn-postcode-input]');
      var toggle = panel.querySelector('[data-nbn-delivery-toggle]');
      var details = panel.querySelector('[data-nbn-delivery-details]');
      var submit = panel.querySelector('[data-nbn-postcode-form] button[type="submit"]');
      var clear = panel.querySelector('[data-nbn-postcode-clear]');
      var result = panel.querySelector('[data-nbn-postcode-result]');
      if (!postcode) {
        var defaultZone = isHomePanel ? 'brisbane' : (panel.dataset.nbnDefaultZone || 'brisbane');
        var defaultSummary = deliverySummaryForZone(defaultZone);
        var hideCollectionHeading = !isHomePanel;
        setTextIfChanged(eyebrow, isHomePanel && defaultZone === 'brisbane' ? 'Brisbane fast delivery' : (defaultZone === 'sydney' ? (defaultSummary.eyebrow || 'Sydney delivery') : PRE_POSTCODE_EYEBROW));
        if (heading) heading.hidden = hideCollectionHeading;
        setTextIfChanged(heading, hideCollectionHeading ? '' : (isHomePanel && defaultZone === 'brisbane' ? (defaultSummary.heading || 'Need it tonight? Brisbane 2-hour delivery.') : (defaultZone === 'sydney' ? (defaultSummary.heading || 'Need it today? Sydney 3-hour delivery.') : PRE_POSTCODE_HEADING)));
        if (message) message.hidden = false;
        setTextIfChanged(message, PRE_POSTCODE_MESSAGE);
        if (summaryLine) summaryLine.hidden = false;
        if (summaryLine && defaultSummary.promiseHtml) {
          setHtmlIfChanged(summaryLine, defaultSummary.promiseHtml);
        } else {
          setTextIfChanged(summaryLine, defaultZone === 'sydney' ? defaultSummary.promise : PRE_POSTCODE_SUMMARY);
        }
        if (timer && defaultSummary.target) {
          var defaultParts = diffParts(defaultSummary.target - localNow(defaultZone === 'sydney' ? 'Australia/Sydney' : 'Australia/Brisbane'));
          updateCountdownElement(timer, defaultSummary, defaultParts);
        }
        if (input && input.value) input.value = '';
        setTextIfChanged(submit, 'Check');
        if (toggle) setTextIfChanged(toggle, 'Check postcode');
        if (clear) clear.hidden = true;
        if (result) {
          result.style.display = 'none';
          if (result.className !== 'nbn-delivery-compact__postcode-result') {
            result.className = 'nbn-delivery-compact__postcode-result';
          }
          setHtmlIfChanged(result, '');
        }
        return;
      }
      var panelPromise = summary.promise + ' Final stock and rate are confirmed at checkout.';
      setTextIfChanged(eyebrow, summary.eyebrow || (info.label + ' delivery'));
      if (heading) heading.hidden = false;
      setTextIfChanged(heading, summary.heading || info.promise);
      if (summaryLine) summaryLine.hidden = false;
      if (message) {
        setTextIfChanged(message, '');
        message.hidden = true;
      }
      if (summaryLine && summary.promiseHtml) {
        setHtmlIfChanged(summaryLine, summary.promiseHtml);
      } else {
        setTextIfChanged(summaryLine, panelPromise);
      }
      if (input && input.value !== postcode) input.value = postcode;
      setTextIfChanged(submit, window.matchMedia && window.matchMedia('(max-width: 430px)').matches ? 'Update' : 'Update postcode');
      if (toggle) {
        setTextIfChanged(toggle, details && !details.hidden ? 'Hide postcode checker' : 'Update postcode');
      }
      if (clear) clear.hidden = false;
      if (result) {
        result.style.display = 'none';
        if (result.className !== 'nbn-delivery-compact__postcode-result') {
          result.className = 'nbn-delivery-compact__postcode-result';
        }
        setHtmlIfChanged(result, '');
      }
      if (timer && summary.target) {
        var parts = diffParts(summary.target - localNow(getZone() === 'sydney' ? 'Australia/Sydney' : 'Australia/Brisbane'));
        updateCountdownElement(timer, summary, parts);
      }
	    });
	  }

  async function fetchStock(variantId){
    if (!variantId) return null;
    if (stockCache[variantId]) return stockCache[variantId];
    stockCache[variantId] = Promise.race([
      fetch(STOCK_ENDPOINT + '?variant_id=' + encodeURIComponent(variantId) + '&_=' + Date.now(), { cache: 'no-store' })
        .then(function(res){ return res.ok ? res.json() : null; }),
      new Promise(function(resolve){ setTimeout(function(){ resolve(null); }, 6000); })
    ])
      .then(function(data){ return data && data.untracked ? '__untracked__' : (data && data.stock) || {}; })
      .catch(function(){ return null; });
    return stockCache[variantId];
  }

  async function fetchProductVariantIds(handle){
    handle = String(handle || '').trim();
    if (!handle) return [];
    if (productVariantCache[handle]) return productVariantCache[handle];
    productVariantCache[handle] = Promise.race([
      fetch('/products/' + encodeURIComponent(handle) + '.js', { cache: 'force-cache' })
        .then(function(res){ return res.ok ? res.json() : null; }),
      new Promise(function(resolve){ setTimeout(function(){ resolve(null); }, 6000); })
    ])
      .then(function(product){
        return product && Array.isArray(product.variants)
          ? product.variants.map(function(variant){ return String(variant && variant.id || ''); }).filter(Boolean)
          : [];
      })
      .catch(function(){ return []; });
    return productVariantCache[handle];
  }

  async function mapWithConcurrency(items, limit, iterator){
    var results = new Array(items.length);
    var index = 0;
    async function worker(){
      while (index < items.length) {
        var current = index++;
        results[current] = await iterator(items[current], current);
      }
    }
    var workers = [];
    for (var i = 0; i < Math.min(limit, items.length); i++) workers.push(worker());
    await Promise.all(workers);
    return results;
  }

  function scoreStock(stock, ids){
    if (stock === '__untracked__') return 999;
    if (!stock || !ids.length) return 0;
    return ids.reduce(function(total, id){ return total + Math.max(0, Number(stock[id] || 0)); }, 0);
  }

  async function scoreProductStock(card, info){
    if (!card || !info || !info.ids || !info.ids.length) return 0;
    var variantIds = [];
    var handle = card.getAttribute('data-nbn-product-handle') || '';
    if (handle) variantIds = await fetchProductVariantIds(handle);
    var cardVariantId = card.getAttribute('data-nbn-variant-id');
    if (cardVariantId && variantIds.indexOf(String(cardVariantId)) === -1) {
      variantIds.unshift(String(cardVariantId));
    }
    if (!variantIds.length && cardVariantId) variantIds = [String(cardVariantId)];
    var scores = await mapWithConcurrency(variantIds, 4, async function(variantId){
      var stock = await fetchStock(variantId);
      return {
        variantId: String(variantId),
        score: scoreStock(stock, info.ids)
      };
    });
    var best = scores
      .filter(function(row){ return row && Number(row.score || 0) > 0; })
      .sort(function(a, b){ return Number(b.score || 0) - Number(a.score || 0); })[0];
    if (best && best.variantId) {
      setCardPreferredVariant(card, {
        preferred_variant_id: best.variantId,
        first_variant_id: cardVariantId || variantIds[0] || ''
      });
    }
    return scores.reduce(function(total, row){ return total + Math.max(0, Number(row && row.score || 0)); }, 0);
  }

  function getCollectionHandle(){
    var grid = document.querySelector('[data-nbn-location-grid]');
    if (grid && grid.dataset.collectionHandle) return grid.dataset.collectionHandle;
    var match = window.location.pathname.match(/^\/collections\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function insertCardBadge(card, badge){
    if (!card || !badge) return;
    var anchor = card.querySelector([
      '.product-card-info--inner .product-card-swatch',
      '.product-card-info--inner .product-card-swatches',
      '.product-card-info--inner .product-card--swatches',
      '.product-card-info--inner .color-swatches',
      '.product-card-info--inner .variant-picker',
      '.product-card-info--inner [class*="swatch"]',
      '.product-card-info--inner [class*="variant"]'
    ].join(', '));
    if (!anchor) {
      anchor = card.querySelector('.product-card-info--inner .price, .product-card-info--inner [class*="price"]') ||
        card.querySelector('.product-card-title');
    }
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(badge, anchor.nextSibling);
  }

  function syncCardLabelReserve(card, badge){
    if (!card || !badge) return;
    var reserve = card.querySelector('[data-nbn-location-card-label-reserve]');
    var labelsAfterBadge = Array.prototype.some.call(card.querySelectorAll('.product-card--label-container'), function(label){
      return !!(badge.compareDocumentPosition(label) & Node.DOCUMENT_POSITION_FOLLOWING);
    });
    if (badge.hidden || labelsAfterBadge) {
      if (reserve) reserve.remove();
      return;
    }
    reserve = reserve || document.createElement('div');
    reserve.className = 'nbn-location-card-label-reserve';
    reserve.setAttribute('data-nbn-location-card-label-reserve', '');
    if (badge.nextSibling !== reserve) {
      badge.parentNode.insertBefore(reserve, badge.nextSibling);
    }
  }

  function setCardBadge(card, score, info){
    var badge = card.querySelector('[data-nbn-location-card-badge]');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'nbn-location-card-badge';
      badge.setAttribute('data-nbn-location-card-badge','');
    }
    insertCardBadge(card, badge);
    if (!getPostcode()) {
      badge.hidden = true;
      syncCardLabelReserve(card, badge);
      return;
    }
    badge.hidden = false;
    if (score > 0) {
      badge.className = 'nbn-location-card-badge is-local';
      if (info.label === 'Gold Coast') badge.textContent = '🚀 Gold Coast same-day delivery';
      else if (info.label === 'Sydney') badge.textContent = '🚀 Sydney 3-hour delivery';
      else if (info.label === 'Brisbane') badge.textContent = '🚀 Brisbane 2-hour delivery';
      else badge.textContent = '🚀 Fast local delivery';
    } else if (card.getAttribute('data-product-available') === 'true') {
      badge.className = 'nbn-location-card-badge is-express';
      badge.textContent = expressPostEta().badge;
    } else {
      badge.hidden = true;
    }
    syncCardLabelReserve(card, badge);
  }

  function setCardPreferredVariant(card, product){
    if (!card || !product) return;
    var preferredVariantId = product.preferred_variant_id || product.first_variant_id || '';
    if (!preferredVariantId) return;
    card.dataset.nbnPreferredVariantId = String(preferredVariantId);
    card.setAttribute('data-nbn-preferred-variant-id', String(preferredVariantId));
    card.querySelectorAll('quick-view[data-product-handle], .product-card--add-to-cart-button[data-product-handle]').forEach(function(button){
      button.dataset.productId = String(preferredVariantId);
      button.setAttribute('data-product-id', String(preferredVariantId));
    });
    var multiVariant = card.querySelector('.multi_variant_id[data-variant-id]');
    if (multiVariant) multiVariant.setAttribute('data-variant-id', String(preferredVariantId));
  }

  function cardSignature(cards){
    return cards.map(function(card){
      return card.getAttribute('data-nbn-product-handle') || card.getAttribute('data-nbn-variant-id') || '';
    }).join('|');
  }

  function visibleCollectionCards(grid){
    if (!grid) return [];
    var cards = Array.prototype.slice.call(grid.querySelectorAll('li.grid__item > product-card[data-nbn-location-card]'));
    var loadedVisibleCards = cards.filter(function(card){
      var li = card.closest('li.grid__item');
      return !li || !li.hidden;
    });
    if (loadedVisibleCards.length) cards = loadedVisibleCards;
    return cards.slice(0, Math.min(120, MAX_COLLECTION_CARDS));
  }

  function notifyCollectionPersonalised(grid){
    if (!grid) return;
    try {
      window.dispatchEvent(new CustomEvent('nbn:collection-personalised', {
        detail: {
          count: grid.querySelectorAll('li.grid__item > product-card[data-nbn-location-card]').length,
          signature: grid.dataset.nbnLocationCardSignature || '',
          source: grid.dataset.nbnLocationRankSource || ''
        }
      }));
    } catch (error) {}
  }
  function collectionContextSignature(){
    try {
      return [
        getPostcode(),
        localStorage.getItem(STORE_FILTER_KEY) || '',
        localStorage.getItem(STORE_FILTER_VALUE_KEY) || '',
        getCollectionHandle()
      ].join('|');
    } catch (error) {
      return [getPostcode(), '', '', getCollectionHandle()].join('|');
    }
  }

  function scheduleCollectionPersonalisation(options){
    options = options || {};
    if (collectionPersonaliseQueued) return;
    collectionPersonaliseQueued = true;
    collectionVisibleLoadingRequested = collectionVisibleLoadingRequested || !!options.visibleLoading;
    collectionReorderRequested = collectionReorderRequested || !!options.allowReorder;
    if (collectionVisibleLoadingRequested && document.querySelector('ul#product-grid.products') && getPostcode()) setCollectionLoading(true);
    setTimeout(function(){
      collectionPersonaliseQueued = false;
      personaliseCollection();
    }, 180);
  }

  function bindEndpointMissBadgeObserver(rows, info){
    endpointMissRows = [];
    endpointMissInfo = null;
    if (endpointMissInterval) {
      clearInterval(endpointMissInterval);
      endpointMissInterval = null;
    }
    if (!rows || !rows.length || !info || !info.ids || !info.ids.length) return;
    endpointMissRows = rows.filter(function(row){
      return row && row.card && row.score <= 0 && row.card.dataset.nbnStoreFilteredBadge !== '1';
    });
    endpointMissInfo = info;
    if (!endpointMissRows.length) return;
    async function verifyRow(row){
      if (!row || !row.card || row.card.dataset.nbnStockFallbackChecked) return;
      var rowInfo = endpointMissInfo;
      if (!rowInfo || !rowInfo.ids || !rowInfo.ids.length) return;
      row.card.dataset.nbnStockFallbackChecked = '1';
      var score = await scoreProductStock(row.card, rowInfo);
      if (score > 0) row.card.dataset.nbnStockFallbackScore = String(score);
      else delete row.card.dataset.nbnStockFallbackScore;
      row.score = score;
      if (row.li) row.li.dataset.nbnLocationScore = String(score);
      setCardBadge(row.card, score, rowInfo);
    }
    function verifyVisibleRows(){
      if (!endpointMissRows.length || !endpointMissInfo) return;
      var topLimit = -900;
      var bottomLimit = window.innerHeight + 900;
      var grid = document.querySelector('ul#product-grid.products');
      var deepStoreCheck = !!(grid && grid.dataset.nbnLocationRankTrigger === 'store-selector');
      var deepCheckedThisPass = 0;
      endpointMissRows.forEach(function(row){
        if (!row || !row.card || row.card.dataset.nbnStockFallbackChecked) return;
        var rect = row.card.getBoundingClientRect();
        var nearViewport = rect.bottom >= topLimit && rect.top <= bottomLimit;
        if (nearViewport || (deepStoreCheck && deepCheckedThisPass < 8)) {
          if (!nearViewport) deepCheckedThisPass += 1;
          verifyRow(row);
        }
      });
    }
    if (!endpointMissScrollBound) {
      endpointMissScrollBound = true;
      var scheduled = false;
      function schedule(){
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function(){
          scheduled = false;
          verifyVisibleRows();
        });
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    }
    setTimeout(verifyVisibleRows, 0);
    setTimeout(verifyVisibleRows, 400);
    endpointMissInterval = setInterval(function(){
      verifyVisibleRows();
      if (!endpointMissRows.some(function(row){ return row && row.card && !row.card.dataset.nbnStockFallbackChecked; })) {
        clearInterval(endpointMissInterval);
        endpointMissInterval = null;
      }
    }, 700);
  }

  async function fetchRankedCollection(postcode, collectionHandle){
    if (!postcode || !collectionHandle) return null;
    try {
      var url = getRankEndpoint() +
        '?postcode=' + encodeURIComponent(postcode) +
        '&collection=' + encodeURIComponent(collectionHandle) +
        '&limit=' + encodeURIComponent(String(RANK_ENDPOINT_LIMIT)) +
        '&_=' + Date.now();
      var response = await Promise.race([
        fetch(url, { cache: 'no-store' }),
        new Promise(function(_, reject){
          setTimeout(function(){ reject(new Error('location rank timeout')); }, RANK_ENDPOINT_TIMEOUT_MS);
        })
      ]);
      if (!response.ok) return null;
      var data = await response.json();
      return data && data.ok && Array.isArray(data.products) ? data : null;
    } catch (error) {
      console.warn('[NBN] Location ranking endpoint unavailable, falling back to card stock checks', error);
      return null;
    }
  }

  async function fetchStoreFilteredHandles(options){
    options = options || {};
    var maxPages = Math.max(1, Number(options.maxPages || 10));
    var allowPartial = options.allowPartial !== false;
    var cached = getCachedStoreFilteredHandles();
    if (cached && (allowPartial || !cached.partial)) return cached;
    var label = '';
    var param = '';
    var value = '';
    try {
      label = localStorage.getItem(STORE_FILTER_KEY) || '';
      param = localStorage.getItem(STORE_FILTER_PARAM_KEY) || '';
      value = localStorage.getItem(STORE_FILTER_VALUE_KEY) || '';
    } catch (error) {}
    if (!label || !param || !value) return null;
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('nbn_postcode');
      url.searchParams.delete('preview_theme_id');
      url.searchParams.set(param, value);
      var handles = [];
      var nextUrl = url.toString();
      var seenUrls = {};
      var pages = 0;
      while (nextUrl && handles.length < RANK_ENDPOINT_LIMIT && !seenUrls[nextUrl] && pages < maxPages) {
        pages++;
        seenUrls[nextUrl] = true;
        var response = await fetch(nextUrl, { cache: 'no-store' });
        if (!response.ok) break;
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        Array.from(doc.querySelectorAll('li.grid__item > product-card[data-nbn-location-card]')).forEach(function(card){
          var handle = card.getAttribute('data-nbn-product-handle') || '';
          if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
        var nextGrid = doc.getElementById('product-grid');
        var nextPath = nextGrid && nextGrid.dataset.nbnNextUrl;
        nextUrl = nextPath ? new URL(nextPath, window.location.origin).toString() : '';
      }
      return handles.length ? setCachedStoreFilteredHandles({ label: label, handles: handles, partial: !!nextUrl }) : null;
    } catch (error) {
      console.warn('[NBN] Store filter handle lookup unavailable', error);
      return null;
    }
  }

  function applyStoreFilteredProducts(grid, cards, storeFilter){
    if (!storeFilter || !Array.isArray(storeFilter.handles) || !storeFilter.handles.length) return false;
    var handleRank = {};
    storeFilter.handles.forEach(function(handle, index){ handleRank[handle] = index + 1; });
    var rows = cards.map(function(card, index){
      var handle = card.getAttribute('data-nbn-product-handle') || '';
      var score = handleRank[handle] ? 1 : 0;
      var badge = card.querySelector('[data-nbn-location-card-badge]');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'nbn-location-card-badge';
        badge.setAttribute('data-nbn-location-card-badge','');
      }
      insertCardBadge(card, badge);
      setCardBadge(card, score, locationInfo());
      var li = card.closest('li.grid__item');
      li.dataset.nbnLocationScore = String(score);
      li.dataset.nbnOriginalIndex = li.dataset.nbnOriginalIndex || String(index);
      return { li: li, score: score, rank: handleRank[handle] || 999999, index: Number(li.dataset.nbnOriginalIndex || index) };
    });
    rows.sort(function(a,b){
      if (b.score !== a.score) return b.score - a.score;
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.index - b.index;
    });
    var fragment = document.createDocumentFragment();
    rows.forEach(function(row){ fragment.appendChild(row.li); });
    grid.insertBefore(fragment, grid.querySelector('li.grid__item') || grid.querySelector('li.loading-overlay') || null);
    grid.classList.add('nbn-location-sorted');
    grid.dataset.nbnLocationRankSource = 'store-filter';
    grid.dataset.nbnLocationRankTrigger = 'store-selector';
    grid.dataset.nbnLocationCardSignature = cardSignature(visibleCollectionCards(grid));
    notifyCollectionPersonalised(grid);
    var note = document.querySelector('[data-nbn-location-collection-note]');
    if (note) note.remove();
    return true;
  }

  function applyStoreFilteredBadges(cards, storeFilter, info){
    if (!storeFilter || !Array.isArray(storeFilter.handles) || !storeFilter.handles.length) return false;
    var handleMap = {};
    storeFilter.handles.forEach(function(handle){ handleMap[handle] = true; });
    var applied = false;
    cards.forEach(function(card){
      var handle = card.getAttribute('data-nbn-product-handle') || '';
      var li = card.closest('li.grid__item');
      var currentScore = Math.max(
        0,
        Number(li && li.dataset.nbnLocationScore || 0),
        Number(card.dataset.nbnStockFallbackScore || 0),
        card.dataset.nbnStoreFilteredBadge === '1' ? 1 : 0
      );
      if (!handleMap[handle]) {
        if (currentScore <= 0) delete card.dataset.nbnStoreFilteredBadge;
        if (li) li.dataset.nbnLocationScore = String(currentScore);
        setCardBadge(card, currentScore, info);
        if (currentScore > 0) applied = true;
        return;
      }
      card.dataset.nbnStoreFilteredBadge = '1';
      currentScore = Math.max(1, currentScore);
      if (li) li.dataset.nbnLocationScore = String(currentScore);
      setCardBadge(card, currentScore, info);
      applied = true;
    });
    return applied;
  }

  function decorateRankedProductsInPlace(grid, cards, ranked, info, storeFilter){
    if (!grid || !ranked || !Array.isArray(ranked.products)) return false;
    var byHandle = {};
    ranked.products.forEach(function(product, index){
      if (!product || !product.handle) return;
      byHandle[product.handle] = Object.assign({}, product, { rank: index });
    });
    var rows = cards.map(function(card, index){
      var handle = card.getAttribute('data-nbn-product-handle') || '';
      var product = byHandle[handle];
      var score = product ? Number(product.local_quantity || 0) : 0;
      var fallbackScore = Number(card.dataset.nbnStockFallbackScore || 0);
      if (score <= 0 && fallbackScore > 0) score = fallbackScore;
      setCardPreferredVariant(card, product);
      setCardBadge(card, score, info);
      var li = card.closest('li.grid__item');
      if (li) {
        li.dataset.nbnLocationScore = String(score);
        li.dataset.nbnOriginalIndex = li.dataset.nbnOriginalIndex || String(index);
      }
      return {
        li: li,
        card: card,
        score: score,
        rank: product ? product.rank : 999999,
        index: li ? Number(li.dataset.nbnOriginalIndex || index) : index
      };
    });
    applyStoreFilteredBadges(cards, storeFilter, info);
    grid.dataset.nbnLocationRankSource = 'endpoint';
    grid.dataset.nbnLocationRankTrigger = localStorage.getItem(STORE_FILTER_KEY) ? 'store-selector' : 'postcode';
    grid.dataset.nbnLocationRankZone = ranked.zone || getZone();
    grid.dataset.nbnLocationRankGeneratedAt = ranked.generated_at || '';
    grid.dataset.nbnLocationCardSignature = cardSignature(visibleCollectionCards(grid));
    bindEndpointMissBadgeObserver(rows, info);
    notifyCollectionPersonalised(grid);
    return true;
  }

  function applyRankedProducts(grid, cards, ranked, info){
    if (!ranked || !Array.isArray(ranked.products)) return false;
    var byHandle = {};
    ranked.products.forEach(function(product, index){
      if (!product || !product.handle) return;
      byHandle[product.handle] = Object.assign({}, product, { rank: index });
    });

    var rows = cards.map(function(card, index){
      var handle = card.getAttribute('data-nbn-product-handle') || '';
      var product = byHandle[handle];
      var score = product ? Number(product.local_quantity || 0) : 0;
      var fallbackScore = Number(card.dataset.nbnStockFallbackScore || 0);
      if (score <= 0 && fallbackScore > 0) score = fallbackScore;
      setCardPreferredVariant(card, product);
      setCardBadge(card, score, info);
      var li = card.closest('li.grid__item');
      li.dataset.nbnLocationScore = String(score);
      li.dataset.nbnOriginalIndex = li.dataset.nbnOriginalIndex || String(index);
      return {
        li: li,
        card: card,
        score: score,
        rank: product ? product.rank : 999999,
        index: Number(li.dataset.nbnOriginalIndex || index)
      };
    });
    if (info && info.ids && info.ids.length && !rows.some(function(row){ return row.score > 0; })) {
      return false;
    }
    rows.sort(function(a,b){
      if (!!b.score !== !!a.score) return b.score - a.score;
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.index - b.index;
    });

    var firstProduct = grid.querySelector('li.grid__item');
    var loading = grid.querySelector('li.loading-overlay');
    var anchor = document.createComment('nbn-location-rank-anchor');
    grid.insertBefore(anchor, firstProduct || loading || grid.firstChild || null);
    var fragment = document.createDocumentFragment();
    rows.forEach(function(row){ fragment.appendChild(row.li); });
    grid.insertBefore(fragment, anchor);
    anchor.parentNode.removeChild(anchor);
    grid.classList.add('nbn-location-sorted');
    grid.dataset.nbnLocationRankSource = 'endpoint';
    grid.dataset.nbnLocationRankTrigger = localStorage.getItem(STORE_FILTER_KEY) ? 'store-selector' : 'postcode';
    grid.dataset.nbnLocationRankZone = ranked.zone || getZone();
    grid.dataset.nbnLocationRankGeneratedAt = ranked.generated_at || '';
    grid.dataset.nbnLocationCardSignature = cardSignature(visibleCollectionCards(grid));
    bindEndpointMissBadgeObserver(rows, info);
    notifyCollectionPersonalised(grid);
    return true;
  }

  async function personaliseCollection(){
    if (collectionPersonaliseRunning) {
      scheduleCollectionPersonalisation({
        visibleLoading: collectionVisibleLoadingRequested,
        allowReorder: collectionReorderRequested
      });
      return;
    }
    collectionPersonaliseRunning = true;
    var shouldShowLoading = collectionVisibleLoadingRequested;
    var allowReorder = collectionReorderRequested;
    collectionVisibleLoadingRequested = false;
    collectionReorderRequested = false;
    var grid = document.querySelector('ul#product-grid.products');
    if (shouldShowLoading && grid && getPostcode()) setCollectionLoading(true);
    try {
      if (!grid) return;
      if (!collectionObserverBound) bindCollectionGridObserver(grid);
      var cards = visibleCollectionCards(grid);
      if (!cards.length) return;
      var info = locationInfo();
      var hasPostcode = !!getPostcode();
      var runSignature = collectionContextSignature();
      function isStaleRun(){
        if (runSignature === collectionContextSignature()) return false;
        scheduleCollectionPersonalisation();
        return true;
      }
      if (hasPostcode && info.ids.length) {
        if (hasStoreSelectorFilter()) {
          var rankedStorePromise = fetchRankedCollection(getPostcode(), getCollectionHandle());
          var selectedStoreFilter = getCachedStoreFilteredHandles() || await fetchStoreFilteredHandles({ maxPages: 1, allowPartial: true });
          if (isStaleRun()) return;
          if (selectedStoreFilter && applyStoreFilteredProducts(grid, cards, selectedStoreFilter)) {
            rankedStorePromise.then(function(selectedStoreRanked){
              if (!selectedStoreRanked || collectionContextSignature() !== runSignature) return;
              decorateRankedProductsInPlace(grid, visibleCollectionCards(grid), selectedStoreRanked, info, selectedStoreFilter);
            }).catch(function(){});
            fetchStoreFilteredHandles({ maxPages: 10, allowPartial: true }).then(function(fullStoreFilter){
              if (!fullStoreFilter || collectionContextSignature() !== runSignature) return;
              applyStoreFilteredBadges(visibleCollectionCards(grid), fullStoreFilter, info);
            }).catch(function(){});
            return;
          }
        }
        var ranked = await fetchRankedCollection(getPostcode(), getCollectionHandle());
        if (isStaleRun()) return;
        if (grid.classList.contains('nbn-location-sorted') && ranked) {
          var sortedStoreFilter = await fetchStoreFilteredHandles();
          if (isStaleRun()) return;
          if (allowReorder && applyRankedProducts(grid, cards, ranked, info)) {
            applyStoreFilteredBadges(visibleCollectionCards(grid), sortedStoreFilter, info);
            var sortedNote = document.querySelector('[data-nbn-location-collection-note]');
            if (sortedNote) sortedNote.remove();
            return;
          }
          decorateRankedProductsInPlace(grid, cards, ranked, info, sortedStoreFilter);
          return;
        }
        if (applyRankedProducts(grid, cards, ranked, info)) {
          var rankedStoreFilter = await fetchStoreFilteredHandles();
          if (isStaleRun()) return;
          applyStoreFilteredBadges(cards, rankedStoreFilter, info);
          var rankedNote = document.querySelector('[data-nbn-location-collection-note]');
          if (rankedNote) rankedNote.remove();
          return;
        }
        var storeFilter = await fetchStoreFilteredHandles();
        if (isStaleRun()) return;
        if (applyStoreFilteredProducts(grid, cards, storeFilter)) return;
      }
      if (hasPostcode && !info.ids.length) {
        cards.forEach(function(card){ setCardBadge(card, 0, info); });
        grid.classList.remove('nbn-location-sorted');
        grid.dataset.nbnLocationRankSource = 'express-post-eta';
        grid.dataset.nbnLocationCardSignature = cardSignature(visibleCollectionCards(grid));
        notifyCollectionPersonalised(grid);
        var expressNote = document.querySelector('[data-nbn-location-collection-note]');
        if (expressNote) expressNote.remove();
        return;
      }
      if (!hasPostcode || !info.ids.length) return;
      var rows = await mapWithConcurrency(cards, STOCK_CONCURRENCY, async function(card, index){
        var score = await scoreProductStock(card, info);
        setCardBadge(card, score, info);
        var li = card.closest('li.grid__item');
        li.dataset.nbnLocationScore = String(score);
        li.dataset.nbnOriginalIndex = li.dataset.nbnOriginalIndex || String(index);
        return { li: li, score: score, index: Number(li.dataset.nbnOriginalIndex || index) };
      });
      if (isStaleRun()) return;
      rows.sort(function(a,b){
        if (!!b.score !== !!a.score) return b.score - a.score;
        if (b.score !== a.score) return b.score - a.score;
        return a.index - b.index;
      });
      var fragment = document.createDocumentFragment();
      rows.forEach(function(row){ fragment.appendChild(row.li); });
      grid.insertBefore(fragment, grid.querySelector('li.grid__item') || grid.querySelector('li.loading-overlay') || null);
      grid.classList.add('nbn-location-sorted');
      grid.dataset.nbnLocationCardSignature = cardSignature(visibleCollectionCards(grid));
      notifyCollectionPersonalised(grid);
      var note = document.querySelector('[data-nbn-location-collection-note]');
      if (note) note.remove();
    } finally {
      collectionPersonaliseRunning = false;
      if (shouldShowLoading) setCollectionLoading(false);
    }
  }

  function bindCollectionGridObserver(grid){
    if (!grid || collectionObserverBound) return;
    collectionObserverBound = true;
    new MutationObserver(function(){
      var cards = visibleCollectionCards(grid);
      var signature = cardSignature(cards);
      if (!signature || signature === grid.dataset.nbnLocationCardSignature) return;
      scheduleCollectionPersonalisation({ allowReorder: false, visibleLoading: false });
    }).observe(grid, { childList: true });
  }

  function updateCartDrawerMessage(){
    var postcode = getPostcode();
    var drawer = document.querySelector('cart-drawer, #Cart-Drawer, .cart-drawer, [data-cart-drawer]');
    if (!drawer || !postcode) return;
    var info = locationInfo();
    var message = drawer.querySelector('[data-nbn-location-cart-message]');
    if (!message) {
      message = document.createElement('div');
      message.className = 'nbn-location-cart-message';
      message.setAttribute('data-nbn-location-cart-message','');
      var target = drawer.querySelector('form, .cart-drawer__footer, .cart-drawer--content') || drawer.firstElementChild || drawer;
      target.insertBefore(message, target.firstChild || null);
    }
    message.textContent = info.label + ' ' + postcode + ': ' + info.promise + '. Final options show at checkout.';
  }

  function applyPersonalisation(options){
    updateBar();
    updateExistingDeliveryPanels();
    updateStoreSelectorState();
    scheduleCollectionPersonalisation(options || {});
    updateCartDrawerMessage();
  }

	  function bindExistingDeliveryPanelForms(){
    if (document.documentElement.dataset.nbnCollectionDeliveryDelegated) return;
    document.documentElement.dataset.nbnCollectionDeliveryDelegated = '1';

    document.addEventListener('click', function(event){
      var clear = event.target && event.target.closest('[data-nbn-postcode-clear]');
      if (clear) {
        event.preventDefault();
        clearPostcode('collection-delivery-panel');
        var clearPanel = clear.closest('[data-nbn-delivery-panel]');
        var clearDetails = clearPanel && clearPanel.querySelector('[data-nbn-delivery-details]');
        var clearToggle = clearPanel && clearPanel.querySelector('[data-nbn-delivery-toggle]');
        if (clearDetails) clearDetails.hidden = false;
        if (clearToggle) {
          clearToggle.setAttribute('aria-expanded', 'true');
          setTextIfChanged(clearToggle, 'Hide postcode checker');
        }
        return;
      }
      var toggle = event.target && event.target.closest('[data-nbn-delivery-toggle]');
      if (!toggle) return;
      var panel = toggle.closest('[data-nbn-delivery-panel]');
      var details = panel && panel.querySelector('[data-nbn-delivery-details]');
      if (!details) return;
      var expanded = details.hidden;
      details.hidden = !expanded;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      setTextIfChanged(toggle, expanded ? 'Hide postcode checker' : (getPostcode() ? 'Update postcode' : 'Check postcode'));
      if (expanded) {
        var input = details.querySelector('[data-nbn-postcode-input]');
        if (input) setTimeout(function(){ input.focus(); }, 0);
      }
    });

	    document.addEventListener('submit', function(event){
	      var form = event.target && event.target.closest('[data-nbn-postcode-form]');
	      if (!form) return;
	      event.preventDefault();
	      var input = form.querySelector('[data-nbn-postcode-input]');
	      var postcode = setPostcode(input && input.value, { actual: true });
	      if (postcode.length === 4) {
	        var panel = form.closest('[data-nbn-delivery-panel]');
	        var details = panel && panel.querySelector('[data-nbn-delivery-details]');
	        var toggle = panel && panel.querySelector('[data-nbn-delivery-toggle]');
	        if (details) details.hidden = true;
	        if (toggle) {
	          toggle.setAttribute('aria-expanded', 'false');
	          setTextIfChanged(toggle, 'Update postcode');
	        }
	        var closestStore = syncStoreSelectorToPostcode(postcode);
	        window.dispatchEvent(new CustomEvent('nbn:postcode-updated', {
	          detail: { postcode: postcode, zone: getZone(), source: 'collection-delivery-panel', store: closestStore, actualPostcode: true }
	        }));
	      }
	    });

    document.querySelectorAll('[data-nbn-postcode-form]').forEach(function(form){
      if (form.dataset.nbnSharedPostcodeBound) return;
      form.dataset.nbnSharedPostcodeBound = '1';
    });
	  }

  function bindStoreSelectorRanking(){
    if (document.documentElement.dataset.nbnStoreSelectorRankingBound) return;
    document.documentElement.dataset.nbnStoreSelectorRankingBound = '1';
    document.addEventListener('click', function(event){
      var option = event.target && event.target.closest('.nbn-store-option');
      if (!option) return;
      if (!storeFilterForOption(option)) return;
      event.preventDefault();
      event.stopPropagation();
      applyStoreSelectorOption(option);
    }, true);
  }

  ready(function(){
    capturePreviewParams();
    installBar();
    applyPersonalisation({ allowReorder: true });
    bindExistingDeliveryPanelForms();
    bindStoreSelectorRanking();
    document.addEventListener('cart:updated', updateCartDrawerMessage);
    document.addEventListener('cart-drawer:open', updateCartDrawerMessage);
    window.addEventListener('nbn:postcode-updated', function(event){
      var postcode = cleanPostcode(event.detail && event.detail.postcode);
      if (postcode.length === 4) capturePostcodeEntry(event.detail || {});
      if (postcode.length === 4 && event.detail && event.detail.source !== 'location-bar' && event.detail.source !== 'collection-store-selector') {
        setPostcode(postcode, { actual: event.detail.actualPostcode !== false });
        if (event.detail.actualPostcode !== false) syncStoreSelectorToPostcode(postcode);
        applyPersonalisation({ visibleLoading: true, allowReorder: true });
      } else if (!postcode && event.detail && event.detail.source !== 'location-bar' && event.detail.source !== 'collection-delivery-panel' && event.detail.source !== 'product-widget') {
        clearPostcode(event.detail.source || 'external-widget');
      }
    });
    window.addEventListener('nbn:postcode-cleared', function(event){
      if (event.detail && event.detail.source !== 'location-bar' && event.detail.source !== 'collection-delivery-panel') {
        try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}
      }
      applyPersonalisation({ allowReorder: true });
    });
    window.addEventListener('nbn:collection-page-appended', function(){
      scheduleCollectionPersonalisation({ visibleLoading: true, allowReorder: true });
    });
    var observer = new MutationObserver(function(){ updateCartDrawerMessage(); });
    observer.observe(document.body, { childList: true, subtree: true });
	    window.setInterval(updateCountdownTimersOnly, 1000);
	    window.setInterval(function(){
	      updateBar();
	      updateExistingDeliveryPanels();
	    }, 30000);
	  });
	})();
